import type { ValidatorConstraintInterface } from "class-validator";
import { ValidatorConstraint } from "class-validator";

@ValidatorConstraint({ name: "is company ID number" })
export class IsCompanyNumber implements ValidatorConstraintInterface {
    public validate(rawCompanyIdNumber: string): boolean {
        if (!rawCompanyIdNumber) {
            return false;
        }

        const containsAtLeastOneNumber = /^.*[0-9]+.*$/.test(rawCompanyIdNumber);
        const containsAllowedCharacters = /^[/\-.A-Za-z0-9]*$/.test(rawCompanyIdNumber);
        const isValid = containsAtLeastOneNumber && containsAllowedCharacters;
        return isValid;
    }

    public defaultMessage(): string {
        return "Company ID NUMBER must contain at least one digit and no spaces. Allowed special characters: /-.";
    }
}
